module.exports = __webpack_public_path__ + "static/img/icon_order.6fb8763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order/icon_order.png
// module id = QjUi
// module chunks = 1